{
  "backButton": "Voltar ao {prevMenuButton}",
  "moreActions": "Mais ações",
  "unavailable": "Indisponível, expandir para mais detalhes"
}
